import { RootState } from '@/plugins/store';
import { GetterTree } from 'vuex';
import { SuiviFacturesPayeesState } from '.';

export const getters: GetterTree<SuiviFacturesPayeesState, RootState> = {
    getSuiviFacturesPayeesScroll(state) {
        return state.scroll;
    },
    getSuiviFacturesPayeesItems(state) {
        return state.facturesPayees;
    },
    getSuiviFacturesPayeesIsLoading(state) {
        return state.isLoading;
    },
    getSuiviFacturesPayeesPage(state) {
        return state.page;
    },
    getSuiviFacturesPayeesNbOfPages(state) {
        return state.nbOfPages;
    },
    getSuiviFacturesPayeesSort(state) {
        return state.sort;
    },
    getSuiviFacturesPayeesCount(state) {
        return state.count;
    },
};
